import React, { useState } from "react";
import { SelectWrapper, SelectLabel, CustomSelect, ErrorMessage } from "./styles";

interface FloatingSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  error?: string;
}

export function FloatingSelect({ label, error, value, children, ...rest }: FloatingSelectProps) {
  const [selectFocused, setSelectFocused] = useState(false);
  const hasValue = value !== undefined && value !== null && value !== "";

  return (
    <SelectWrapper>
      <SelectLabel 
        $hasError={!!error} 
        $isFocused={selectFocused}
        $hasValue={hasValue}
      >
        {label}
      </SelectLabel>
      <CustomSelect 
        value={value} 
        onFocus={(e) => {
          setSelectFocused(true);
          if (rest.onFocus) rest.onFocus(e);
        }}
        onBlur={(e) => {
          setSelectFocused(false);
          if (rest.onBlur) rest.onBlur(e);
        }}
        $hasError={!!error}
        {...rest}
      >
        {children}
      </CustomSelect>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </SelectWrapper>
  );
}
